import { createFeatureSelector, createSelector, ActionReducerMap } from '@ngrx/store'
import { ItemTypeEnum } from './items.models'
import * as fromItem from './items.reducer'
import { ITEMS_FEATURE_KEY } from './items.reducer'

export interface RootState {
  items: fromItem.ItemState
}

export const reducers: ActionReducerMap<RootState> = {
  items: fromItem.ItemReducer,
}

export const selectItemState = createFeatureSelector<fromItem.ItemState>(ITEMS_FEATURE_KEY)

export const selectCurrentFilters = createSelector(selectItemState, (state) => state.filters)

export const selectItemEntities = createSelector(selectItemState, fromItem.selectEntities)

export const selectAllItems = createSelector(selectItemState, fromItem.selectAll)

export const selectAllListLoadedItems = createSelector(selectAllItems, (items) =>
  items.filter((item) => !item.notListLoaded),
)

export const selectItemTotal = createSelector(selectItemState, fromItem.selectTotal)

export const selectItemCount = createSelector(selectItemState, (state) => state.count)

export const selectItemOrder = createSelector(selectItemState, (state) => state.order)

export const selectErrorMessage = createSelector(selectItemState, (state) => state.error)

export const selectShowPoppers = createSelector(selectItemState, (state) => state.showPoppers)

export const selectStaleState = createSelector(selectItemState, (state) => state.stale)

export const selectStalePages = createSelector(selectStaleState, (stale) => (stale && stale.pages ? stale.pages : []))

export const selectStaleFilteredPages = createSelector(selectStaleState, (stale) =>
  stale && stale.filteredPages ? stale.filteredPages : [],
)

export const selectItemById = (uuid: string) => createSelector(selectItemEntities, (entities) => entities[uuid])

export const selectFilteredItemById = (uuid: string) =>
  createSelector(selectFilteredItems, (filteredItems) => filteredItems.find((item) => item.uuid === uuid))

export const selectFilteredItems = createSelector(selectItemState, (state) =>
  state.filteredItems ? state.filteredItems : [],
)

export const selectFilteredItemsIds = createSelector(selectFilteredItems, (filteredItems) =>
  filteredItems.map((item) => item.uuid),
)

export const selectBidItems = createSelector(selectAllItems, (items) =>
  items.filter((item) => item.item_type === ItemTypeEnum.Bidding),
)

export const selectHasBidItems = createSelector(selectBidItems, (items) => items && items.length > 0)

export const selectDonationItems = createSelector(selectAllItems, (items) =>
  items.filter((item) => item.item_type == ItemTypeEnum.Donation),
)

export const hasDonationItems = createSelector(selectDonationItems, (items) => items && items.length > 0)
